/// <reference types="vite/client" />
// ============================================================
//  SITE CONFIG — values come from Railway environment variables
//  To update: Railway → frontend service → Variables
//  No code changes or redeployment needed.
// ============================================================

const year  = import.meta.env.VITE_TNEA_YEAR  || '2025';
const price = import.meta.env.VITE_CONSULT_FEE || '₹2,000';

export const SITE_CONFIG = {
  year,
  consultationFee:  price,
  whatsappNumber:   import.meta.env.VITE_WHATSAPP_NUMBER  || '918122552867',
  bannerText:       import.meta.env.VITE_BANNER_TEXT       || 'Need help choosing your college? Expert counseling available',
  modalTitle:       `TNEA ${year} Counseling`,
  whatsappMessage:  `Hi, I need personalized counseling for TNEA ${year} college selection.`,
};
